import development from './env/development'
import production from './env/production'

let config = {}

if (process.env.REACT_APP_ENV === 'production') {
    console.log = function () {};
}


switch (process.env.REACT_APP_ENV) {
    case 'development':
        config = development;
        break;
    case 'production':
        config = production;
        break;
    default:
        config = development;
        break;
}

export default config
